export class SessionCardRemoveAction {
  static readonly type = '[SessionState] Card remove';

  constructor(readonly cardId: string) {}
}
